import { memo, useMemo } from "react";

import { useInitialized } from "../../../model/beds24/use-case";
import { ReferenceArticles, SettingsSiteControllerHeader } from "../_shared";
import { REFERENCE_ARTICLES } from "./constants";
import { useSettingsSiteControllerBeds24 } from "./hooks";
import { SettingsSiteControllerBeds24MainIsland } from "./island/main";
import { SettingsSiteControllerBeds24ManualDataSyncIsland } from "./island/manual-data-sync";

import type { SiteControllerSettingBaseFormModel } from "../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../model/base/use-case/use-create-model/use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
	resetViewModel: () => void;
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	queryData: SiteControllerSettingBaseFormModel["QueryData"];
};

export const SettingsSiteControllerBeds24 = memo(
	({
		viewModel: baseViewModel,
		onSetViewModel, //
		resetViewModel,
		siteControllerSettingBaseFormModelMethodsType,
		queryData,
	}: Props) => {
		const { beds24ViewModel, siteControllerSettingBeds24FormModelMethods } = useInitialized({
			baseViewModel,
			onSetViewModel,
		});

		const { onUpdate } = useSettingsSiteControllerBeds24({
			viewModel: beds24ViewModel,
			onResetViewModel: resetViewModel,
		});

		const isValid = useMemo(
			() => baseViewModel.isDirty && !baseViewModel.hasError,
			[baseViewModel.hasError, baseViewModel.isDirty],
		);

		return (
			<>
				<SettingsSiteControllerHeader onUpdate={onUpdate} isValid={isValid} />

				<ReferenceArticles articles={REFERENCE_ARTICLES} />

				<SettingsSiteControllerBeds24MainIsland
					hotelID={baseViewModel.hotelID}
					baseViewModel={baseViewModel}
					siteControllerSettingBaseFormModelMethodsType={siteControllerSettingBaseFormModelMethodsType}
					beds24ViewModel={beds24ViewModel}
					siteControllerSettingBeds24FormModelMethods={{ siteControllerSettingBeds24FormModelMethods }}
					queryData={queryData}
				/>

				<SettingsSiteControllerBeds24ManualDataSyncIsland
					beds24ViewModel={beds24ViewModel}
					siteControllerSettingBeds24FormModelMethods={{ siteControllerSettingBeds24FormModelMethods }}
				/>
			</>
		);
	},
);

SettingsSiteControllerBeds24.displayName = "SettingsSiteControllerBeds24";
